import type {
  WhatsappOriginalTemplate,
  WhatsappTemplate,
  WhatsappTemplateComponent,
  WhatsappTemplateHebrewName,
} from 'types/templates';

/**
 * כשאין רשומה ב־store (whatsappTemplates) אבל יש originalTemplate —
 * בונים אובייקט מינימלי ל־GetTemplateWithMediaDataFromObject / שליחה.
 * לא מחליף תגובת שרת; רק מאפשר טעינת spec ושליחה כשההתאמה לפי id/name נכשלת.
 */
export function synthesizeWhatsappTemplateFromOriginal(
  original: WhatsappOriginalTemplate,
): WhatsappTemplate {
  const emptyHebrew = {
    CompanyId: '',
    DraftTemplatObject: null,
    hebrewTemaplateName: '',
    Id: 0,
    IsDraft: false,
    OriginalTemplateName: original.name,
    UniqueId: '',
  } as WhatsappTemplateHebrewName;

  return {
    category: (original.category || 'UTILITY') as WhatsappTemplate['category'],
    components: original.components as unknown as WhatsappTemplateComponent[],
    hebrewName: emptyHebrew,
    id: original.id ?? null,
    isParameters: true,
    langugage: original.language,
    name: original.name,
    templateStatus: original.status ?? 'APPROVED',
    text: '',
  };
}
